// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-drawer {
    position: fixed;
    top: 1%;
    right: -50%;
    width: 40%;
    height: 95%;
    background-color: #fff;
    padding: 10px;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.5);
    transition: right 0.4s ease;
}

.side-drawer .close {
    font-size: 45px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    width: -moz-fit-content;
    width: fit-content;
    line-height: 28px;
}

.side-drawer ul {
    margin: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    height: 90%;
}

.side-drawer ul li{
    width: 60%;
}
.side-drawer ul a {
    line-height: 160%;
    text-decoration: none;
    color: black;
    font-size: 4vw;
    border-left: 0;
    /*padding-left: 20px;*/
    transition: border 0.3s ease-in-out;
}

.side-drawer ul a:visited {
    color: black;
}

.side-drawer ul a.active{
    font-weight: bold;
    border-bottom: 2px outset gray;
}

.side-drawer .navBtn span {
    background-color: white;
}

.side-drawer .inventoryStatus {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    align-items: center;
    border: 1px solid #be976b;
}

.side-drawer .inventoryStatus > div {
    width: 100%;
}

.side-drawer .inventoryStatus > div:first-child {
    font-weight: bold;
    background-color: #be976b;
    color: white;
    padding: 5px 0;
    font-size: 14px;
}

.side-drawer .inventoryStatus > div:nth-child(2) {
    display: flex;
    align-items: center;
    padding: 0;
    font-size: 11px;
}
.side-drawer .inventoryStatus > div > div{
    padding: 10px;
}
.side-drawer .inventoryStatus > div > div:nth-child(1){
    background-color: #efefef;
    width: 60%;
}
.side-drawer .inventoryStatus > div > div:nth-child(2){
    width: 40%;
}
.side-drawer .accessController {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 0;
    font-size: 3.8vw;
}

.side-drawer .accessController #logoutBtn {
    font-size: 3.8vw;
    margin: 0;
    padding: 5px 8px;
}

.side-drawer > div {
    display: flex;
    flex-direction: column;
    height: 90%;
    justify-content: space-between;
}

.side-drawer.open {
    right: 0; /* 열린 상태일 때 사이드 드로어를 화면 안쪽으로 이동합니다. */
}
`, "",{"version":3,"sources":["webpack://./src/styles/SideDrawer.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,OAAO;IACP,WAAW;IACX,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,4BAA4B;IAC5B,+BAA+B;IAC/B,wCAAwC;IACxC,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,cAAc;IACd,cAAc;IACd,sBAAsB;IACtB,mCAAmC;AACvC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,QAAQ,EAAE,qCAAqC;AACnD","sourcesContent":[".side-drawer {\n    position: fixed;\n    top: 1%;\n    right: -50%;\n    width: 40%;\n    height: 95%;\n    background-color: #fff;\n    padding: 10px;\n    border-top-left-radius: 20px;\n    border-bottom-left-radius: 20px;\n    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.5);\n    transition: right 0.4s ease;\n}\n\n.side-drawer .close {\n    font-size: 45px;\n    cursor: pointer;\n    display: flex;\n    flex-direction: row;\n    width: fit-content;\n    line-height: 28px;\n}\n\n.side-drawer ul {\n    margin: 0;\n    list-style: none;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-evenly;\n    height: 90%;\n}\n\n.side-drawer ul li{\n    width: 60%;\n}\n.side-drawer ul a {\n    line-height: 160%;\n    text-decoration: none;\n    color: black;\n    font-size: 4vw;\n    border-left: 0;\n    /*padding-left: 20px;*/\n    transition: border 0.3s ease-in-out;\n}\n\n.side-drawer ul a:visited {\n    color: black;\n}\n\n.side-drawer ul a.active{\n    font-weight: bold;\n    border-bottom: 2px outset gray;\n}\n\n.side-drawer .navBtn span {\n    background-color: white;\n}\n\n.side-drawer .inventoryStatus {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 20px;\n    align-items: center;\n    border: 1px solid #be976b;\n}\n\n.side-drawer .inventoryStatus > div {\n    width: 100%;\n}\n\n.side-drawer .inventoryStatus > div:first-child {\n    font-weight: bold;\n    background-color: #be976b;\n    color: white;\n    padding: 5px 0;\n    font-size: 14px;\n}\n\n.side-drawer .inventoryStatus > div:nth-child(2) {\n    display: flex;\n    align-items: center;\n    padding: 0;\n    font-size: 11px;\n}\n.side-drawer .inventoryStatus > div > div{\n    padding: 10px;\n}\n.side-drawer .inventoryStatus > div > div:nth-child(1){\n    background-color: #efefef;\n    width: 60%;\n}\n.side-drawer .inventoryStatus > div > div:nth-child(2){\n    width: 40%;\n}\n.side-drawer .accessController {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    margin: 0;\n    font-size: 3.8vw;\n}\n\n.side-drawer .accessController #logoutBtn {\n    font-size: 3.8vw;\n    margin: 0;\n    padding: 5px 8px;\n}\n\n.side-drawer > div {\n    display: flex;\n    flex-direction: column;\n    height: 90%;\n    justify-content: space-between;\n}\n\n.side-drawer.open {\n    right: 0; /* 열린 상태일 때 사이드 드로어를 화면 안쪽으로 이동합니다. */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
